import React, { MouseEvent, useRef } from 'react';
import classnames from 'classnames/bind';
import { currentZone } from '@portal-root/geo-utils';
import { BrowserLink } from '@/_kit/browser-link';
import { EColors, ECountries } from '@/_types';
import { WbPartnersLogo } from './_components/wb-partners-logo';
import { WbPartnersLogoTr } from './_components/wb-partners-logo-tr';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Logo';

type TProps = {
  onClick?: () => void;
  logoColor: EColors;
};

export const Logo = ({ onClick, logoColor }: TProps) => {
  const iconRef = useRef<SVGSVGElement>(null);
  const isTurkey = currentZone.endsWith(ECountries.TR);

  const scrollToTop = ({ event }: { event: MouseEvent<HTMLAnchorElement> }) => {
    event.preventDefault();
    event.stopPropagation();

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={cn(BLOCK_NAME)}>
      <BrowserLink onClick={scrollToTop} routeName="">
        {isTurkey ? (
          <WbPartnersLogoTr />
        ) : (
          <WbPartnersLogo ref={iconRef} color={logoColor} />
        )}
      </BrowserLink>
    </div>
  );
};
